import React from 'react';
import { Helmet } from 'react-helmet';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-us">
      <Helmet>
        <title>
          About Pushkar Enterprises | Plastic Safety Eyes Manufacturer in India
        </title>

        <meta
          name="description"
          content="Pushkar Enterprises is a leading plastic safety eyes manufacturer in India since 1997. We supply soft toy eyes, noses, amigurumi eyes & plush toy accessories in bulk from Delhi."
        />

        <meta
          name="keywords"
          content="plastic safety eyes manufacturer India, soft toy eyes supplier Delhi, amigurumi eyes bulk India, teddy bear eyes manufacturer, toy noses manufacturer India, plush toy accessories supplier"
        />

        <meta name="robots" content="index, follow" />

        <link rel="canonical" href="https://pushkar-enterprises.web.app/about" />
      </Helmet>

      <div className="about-us-container">
        
        {/* 🔥 SEO Optimized Heading */}
        <h1 className="about-us-title">
          Plastic Safety Eyes Manufacturer in India – Pushkar Enterprises
        </h1>

        <h2>Established Soft Toy Eyes & Noses Supplier Since 1997</h2>

        {/* 🔥 SEO-Optimized First Paragraph */}
        <p className="about-us-text">
          Established in <strong>1997</strong>, <strong>Pushkar Enterprises</strong> is a leading 
          <strong> plastic safety eyes manufacturer in India</strong> and a trusted 
          <strong> soft toy eyes supplier in Delhi</strong>. We specialize in manufacturing 
          <strong> soft toy eyes, teddy bear eyes, amigurumi eyes, and plastic toy noses</strong> 
          for bulk buyers, exporters, and plush toy manufacturers worldwide.
        </p>

        <p className="about-us-text">
          Over the years, we have built a strong reputation for delivering high-quality 
          <strong> plastic toy accessories</strong> with consistent sizing, smooth finishing, 
          and durable locking systems. Our products are widely used in 
          <strong> stuffed toys, crochet toys, plush toys, and custom soft toy manufacturing</strong>.
        </p>

        <p className="about-us-text">
          Our journey began with a vision to enhance the look and appeal of plush toys 
          through precision-crafted components. Every product we manufacture reflects 
          our commitment to quality, safety, and innovation.
        </p>

        <p className="about-us-text">
          We combine traditional manufacturing expertise with modern production techniques 
          to ensure consistency and efficiency. Our team focuses on delivering reliable 
          products that meet the needs of both small-scale creators and large manufacturers.
        </p>

        {/* 🔥 SEO Section */}
        <h2>Why Choose Pushkar Enterprises?</h2>

        <p className="about-us-text">
          We are known for manufacturing high-quality plastic safety eyes and toy accessories 
          that meet industry standards. Our products are designed for secure fitting, long-lasting 
          durability, and attractive finishing, making them ideal for soft toys and plush products.
        </p>

        <p className="about-us-text">
          As a Delhi-based manufacturer, we supply across India and export globally. 
          Our ability to handle bulk orders, maintain quality consistency, and offer 
          competitive pricing makes us a preferred supplier in the soft toy industry.
        </p>

        <p className="about-us-text">
          Whether you are a toy manufacturer, exporter, or a DIY amigurumi creator, 
          Pushkar Enterprises provides reliable solutions for all your soft toy accessory needs.
        </p>

      </div>
    </div>
  );
};

export default AboutUs;